export const legendItemsConfig = [
  {
    label: 'Real sales',
    color: 'var(--chart-real-sales)',
    type: 'line',
    description: 'Historical sales data',
  },
  {
    label: 'Real sales average',
    color: 'var(--chart-real-sales-average)',
    type: 'line',
    description: 'Real sales average',
  },
  {
    label: 'B2B sales',
    color: 'var(--chart-b2b-sales)',
    type: 'line',
    description: 'Business-to-business sales',
  },
  {
    label: 'Stock disponibility',
    color: 'var(--chart-stock)',
    type: 'area',
    description: 'Inventory stock percentage',
  },
  {
    label: 'Validated forecast',
    color: 'var(--chart-validated-forecast)',
    type: 'dashed-line',
    description: 'Approved forecast values',
  },
  {
    label: 'Forecast proposal',
    color: 'var(--chart-forecast-proposal)',
    type: 'line',
    description: 'Proposed forecast values',
  },
  {
    label: 'Model proposal',
    color: 'var(--chart-model-proposal)',
    type: 'dashed-line',
    description: 'AI model predictions',
  },
  {
    label: 'Model proposal 2',
    color: 'var(--chart-model-proposal-2)',
    type: 'dashed-line',
    description: 'AI model predictions',
  },
  {
    label: 'Price index',
    color: 'var(--chart-product-price)',
    type: 'dotted-line',
    description: 'Product price trends',
  },
];
